module.exports = __webpack_public_path__ + "img/meeting_banner.8056f427.jpg";